import { render, staticRenderFns } from "./RetentionTime.vue?vue&type=template&id=95d2b47e&scoped=true"
import script from "./RetentionTime.vue?vue&type=script&lang=js"
export * from "./RetentionTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d2b47e",
  null
  
)

export default component.exports